module.exports = __webpack_public_path__ + "static/DMSans-Regular-f6db613e4aaf9a5be1341ad41a790e40.woff2";